import { FormGroup } from "@angular/forms";
import { IFormMapping, IProducPosttDtoModel, PrefixService, ToSAPPartNumberPipe } from "lib-core-shared";
export class ProductFormDetailMapping implements IFormMapping<IProducPosttDtoModel|undefined> {
    constructor(private prefixService: PrefixService) {}
    toApplicationModel(group: FormGroup): IProducPosttDtoModel | undefined {
        return  {
            productTypeCode:  group?.controls?.productType?.value.code,
            englishShortTitle: group?.controls?.englishShortTitle?.value,
            partNumber: new ToSAPPartNumberPipe(this.prefixService).transform(group?.controls?.partNumber?.value.toUpperCase()),
            partStatusCode: group?.controls?.masterProductSatus?.value.code,
            componentStatusCode: group?.controls?.componentStatus?.value.code,
            countryOfOriginCode: group?.controls?.countryOfOriginCode?.value.code,
            commodity: {
                ukCode:  String(group?.controls?.ukCommodityCode?.value),
                usCode:  String(group?.controls?.usCommodityCode?.value)
            },
            taxonomyCode: group.controls.taxonomyCode?.value?.code,
            taxRateCategoryCode:  group?.controls?.taxRateCategory?.value?.code,
            discountCategoryCode:  group?.controls?.discountCategories?.value.code,
          } as IProducPosttDtoModel;
    }

    toForm(model: IProducPosttDtoModel | undefined, group: FormGroup): void {
        if (model) {
            group.controls.partNumber.setValue(model?.partNumber);
            group.controls.englishShortTitle.setValue(model?.englishShortTitle);
            group.controls.masterProductSatus.setValue({
                "code": "Y",
                "name": "Available",
                "actionTitle": "Make Available"
            });
            group.controls.usCommodityCode.setValue(model?.commodity?.usCode);
            group.controls.countryOfOriginCode.setValue({
                "code": "GB",
                "name": "United Kingdom"
            });
            group.controls.componentStatus.setValue({
                "code": "N",
                "name": "No"
            });
            group.controls.ukCommodityCode.setValue(model?.commodity?.ukCode);
            group.controls.taxonomyCode.setValue(model?.taxonomyCode);
            group.controls.taxRateCategory.setValue({
                "code": "TAX1",
                "name": "Tax Rate 1"
            });
            group.controls.discountCategories.setValue({
                "code": "#0",
                "name": "#0"
            });
            group.controls.productType.setValue(model?.productTypeCode);
        }
    }
}